<template>
  <pu-popover v-if="oneUnitPerPitch" v-bind="$attrs">
    <template #content>
      <translate :tt="{ categoriesText }">
        Only one {categoriesText} unit allowed per pitch (not including pup
        tent, awning, gazebo).
      </translate>
    </template>
  </pu-popover>
  <pu-popover v-else v-bind="$attrs">
    <template #content>
      <translate :tt="{ categoriesText }">
        Multiple {categoriesText} are allowed per pitch.
      </translate>
      <translate tag="p">
        Please ensure your units will fit within the pitch size listed, and that
        you do not exceed the max. persons for this pitch.
      </translate>
    </template>
  </pu-popover>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { AllowedSubcategory } from '../../apps/campsite-details/types'

@Component
class UnitPerPitchPopup extends Vue {
  @Prop({ required: true })
  oneUnitPerPitch: boolean

  @Prop({ required: true })
  allowedSubcategories: AllowedSubcategory[]

  get categoriesText() {
    return this.allowedSubcategories.join(` ${this.$t('or')} `)
  }
}

export default toNative(UnitPerPitchPopup)
</script>
